import { NgModule, ModuleWithProviders, SkipSelf, Optional, Provider } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AccountingXatSvc } from './api/accounting.service';
import { AuthenticationXatSvc } from './api/authentication.service';
import { CompaniesXatSvc } from './api/companies.service';
import { DocumentsXatSvc } from './api/documents.service';
import { InvitationsXatSvc } from './api/invitations.service';
import { ModulesXatSvc } from './api/modules.service';
import { NewsXatSvc } from './api/news.service';
import { RequestsXatSvc } from './api/requests.service';
import { SyslogsXatSvc } from './api/syslogs.service';
import { UsersXatSvc } from './api/users.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class XatenaApiModule {


    public static forRoot(
        loader: Provider
    ): ModuleWithProviders<XatenaApiModule> {
        return {
            ngModule: XatenaApiModule,
            providers: [loader],
        };
    }

//    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<XatenaApiModule> {
//        return {
//            ngModule: XatenaApiModule,
//            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
//        };
//    }

    constructor( @Optional() @SkipSelf() parentModule: XatenaApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('XatenaApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
